import { axios } from 'api'
import React, { useCallback, useEffect, useState } from 'react'
import ProgramHeader from './ProgramHeader'
import SchemaSectionRenderer from 'components_v1/SchemaSectionRenderer/series'
import BottomWidgetTempEntry from 'components_v1/bottomWidget/BottomWidgetTempEntry'
import CommentSection from 'components_v1/comments/CommentSection'
import styled from 'styled-components'
import WorkoutsSection from 'components_v1/WorkoutsSection'
import BonusItems from './BonusItems'
import AloversaryPixleeWidget from 'components_v1/ClassView/AloversaryPixleeWidget'
import Ga4Push from 'components_v1/ClassView/Ga4Push'
import PlanCoachInfo from './PlanCoachInfo'
import { useWindowResize } from 'hooks'
import { useParams } from 'react-router-dom'
import { flattenMeta, useMeta, useTitle } from 'hooks/useMetaTitle'
import { useCommonEntryContext } from 'components_v2/common'
import NotAvailable from 'components_v2/_entryPoints/grouped/NotAvailable'
import { ProgramViewContext } from 'components_v2/page_context'

const Main = styled.div`
  margin-bottom: 20px;
  @media (min-width: 768px) {
    .tags-container {
      padding-left: 30px;
      padding-top: 20px;
    }
  }
  .readmore-js-section {
    width: 100%;
  }
  .grey-bottom-mobile {
    .readmore-js-toggle {
      margin-left: 0;
    }
    .readmore-js-collapsed {
      margin-bottom: 8px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 950px) {
    .video-js .vjs-control-bar {
      > * {
        margin-left: -6px;
      }
    }
  }
`

const ProgramView = ({ initTab = 'overview' }) => {
  const { program_id: id } = useParams()
  const [programData, setProgramData] = useState({})
  const { user, setNotFound } = useCommonEntryContext()
  const [loaded, setLoaded] = useState({ plan: false, data: false })
  const [plan, setPlan] = useState(null)
  const [tab, setTab] = useState(initTab)
  const { width } = useWindowResize()
  const isMobile = width < 768
  useTitle(plan?.title)
  useMeta([
    {
      name: 'description',
      content: plan?.description
    },
    {
      name: 'keywords',
      content: programData?.keywords?.join(', ')?.toLowerCase()
    },
    ...flattenMeta({
      og: {
        title: plan?.title,
        description: plan?.description,
        type: 'product',
        url: plan?.planUrl,
        image: [
          {
            _: plan?.coverPhoto?.url,
            width: 320,
            height: 180
          }
        ]
      }
    })
  ])

  useEffect(() => {
    axios
      .get(`/plans/data/${id}`, { load: true })
      .then((res) => {
        const data = res.data
        if (data) {
          setProgramData(data)
          setLoaded((state) => ({ ...state, data: true }))
        }
      })
      .catch((err) => {
        setNotFound(true)
        console.log(err)
      })
  }, [id, setNotFound])

  const fetchPlan = useCallback(() => {
    setPlan(null)
    axios
      .get(`/plans/${id}`)
      .then((res) => {
        if (res.data?.id) {
          setPlan((state) => ({ ...state, ...res.data }))
          setLoaded((state) => ({ ...state, plan: true }))
        }
      })
      .catch((err) => console.log(err))
  }, [id])
  useEffect(() => {
    fetchPlan()
  }, [fetchPlan])
  const coachList = plan?.coaches?.map((c) => ({
    slug: c?.slug,
    fullName: [c?.firstName, c?.lastName].join(' ')
  }))
  const bonus = programData?.bonus
  const widgetPixleeId = programData?.widgetPixleeId
  const introVideo = programData?.introVideo
  const apiKey = programData?.apiKey

  if (!plan || Object.values(loaded).includes(false)) return null
  if (programData?.softDeleted) return <NotAvailable />
  return (
    <ProgramViewContext.Provider
      value={{
        plan,
        setPlan,
        fetchPlan,
        user,
        bonus,
        introVideo,
        setTab,
        tab,
        isMobile
      }}
    >
      <Main>
        <Ga4Push plan={plan} />
        <ProgramHeader />

        {plan?.isStructuredSeries ? (
          <div className='section-bottom-widget series sections'>
            <SchemaSectionRenderer planId={plan.id} user={user} />
          </div>
        ) : (
          <div id='plan-workouts-shell'>
            <div className='container-plan-workouts all-sections-container'>
              <div className='section-container grid-plan-workouts'>
                <WorkoutsSection
                  planDetails={{ id: plan.id, slug: plan.slug }}
                  user={user}
                />
                <BonusItems plan={plan} />
              </div>
            </div>
          </div>
        )}
        {tab === 'overview' && (
          <>
            {user && (
              <>
                {widgetPixleeId && plan?.slug === 'the-dancebody-program' && (
                  <AloversaryPixleeWidget
                    widgetPixleeId={widgetPixleeId}
                    apiKey={apiKey}
                  />
                )}
                <div className='section-bottom-widget series'>
                  <BottomWidgetTempEntry
                    id={plan.id}
                    type='series'
                    user={user}
                  />
                </div>
              </>
            )}
            {isMobile && (
              <div class='grey-bottom-mobile'>
                <div>
                  {plan?.coaches?.length > 0 && <PlanCoachInfo plan={plan} />}
                </div>
              </div>
            )}
            {user && plan?.unlocked && (
              <div className='post-comment'>
                <CommentSection
                  coaches={coachList}
                  classDetails={{
                    id: plan.id,
                    title: plan.title
                  }}
                  type='SERIES'
                  user={user}
                />
              </div>
            )}
          </>
        )}
      </Main>
    </ProgramViewContext.Provider>
  )
}

export default ProgramView
